export default "__VITE_ASSET__BGcajkaB__"